<style lang="less" scoped>
  @import "~src/style/mixin.less";
  .content-top{
    height: 150px;
    margin-top: 20px;
    color: @fc9;
    font-size: 12px;
    background: #ffffff;
    .part-1{
      margin-left: 40px;
      .head-img{
        width: 60px;
        height: 60px;
        margin-right: 30px;
        border-radius: 30px;
      }
      .p-title{
        margin-bottom: 10px;
        color: @fc3;
        font-size: 16px;
      }
      .p-text{
        margin-bottom: 10px;
      }
      .span-test{
        padding: 2px 8px;
        border-radius: 8px;
        color: @act;
        background: #ECF3FF;
      }
    }
    .part-2{
      margin-left: 140px;
      .p-money{
        display: flex;
        align-items: center;
        margin: 6px 0;
        color: @fc3;
        font-size: 24px;
      }
      .span-money{
        color: @fc3;
        vertical-align: 0px;
      }
      .icon-information{
        font-size: 16px;
        margin-right: 5px;
        vertical-align: -1px;
      }
    }
    .part-3{
      margin-left: 112px;
    }
  }
  .content-center{
    height: 260px;
    margin-top: 20px;
    .part{
      width: 32.8%;
      height: 100%;
      color: @fc9;
      font-size: 12px;
      text-align: center;
      background: #ffffff;
      cursor: pointer;
      .content-example{
        padding: 10px 10px 16px 0;
        text-align: right;
      }
      .span-btn-example{
        display: inline-block;
        padding: 3px 9px;
        font-size: 12px;
        font-weight: 500;
        color: #00BBEE;
        background: #E5F8FD;
        border-radius: 3px;
        cursor: pointer;
      }
      .part-img{
        width: 48px;
        height: 48px;
        padding: 5px;
        box-sizing: border-box;
      }
      .p-title{
        margin: 30px 0 46px;
        color: @fc3;
        font-size: 16px;
      }
      .p-act{
        padding: 14px 0;
        color: #00BBEE;
        cursor: pointer;
      }
    }
    .part1, .part2{
      .p-title{
        margin: 30px 0 0;
      }
    }
    .part-2{
      margin: 0 10px;
    }
  }
  .content-footer{
    width: 100%;
    height: 150px;
    margin:20px 0 40px;
    cursor: pointer;
    background: url('https://qiniu-image.qtshe.com/qtbao/pc/qtbao-banner-1230.png') no-repeat center;
    background-size: 100%;
  }
  @media screen and (min-width: 1230px) {
    .content-footer{
      height: 234px;
      background: url('https://qiniu-image.qtshe.com/qtbao/pc/qtbao-banner-1920.png') no-repeat center;
      background-size: 100%;
    }
  }
</style>
<template>
  <section class="section-main">
    <div class="content-top f-js-ac">
      <div class="part-1 f-js-ac">
        <img class="head-img" :src="$userInfo.company.logo" alt="company-logo">
        <div>
          <p class="p-title">{{$wallet.companyName}}</p>
          <p class="p-text">负责人-{{$wallet.chargerName}}</p>
          <span class="span-test" v-if="$wallet.role===1">主账户</span>
          <span class="span-test" v-if="$wallet.role===2">子账户</span>
        </div>
      </div>
      <div class="part-2">
        <p>账户余额（元）</p>
        <p class="p-money">{{$wallet.money}}
          <img @click="handleRefresh" style="width: 33px; margin-left: 10px; cursor: pointer;" src="https://qiniu-image.qtshe.com/qtb_bank_refresh.png" alt="">
        </p>
        <p>
          <el-tooltip class="item" effect="dark" placement="bottom">
            <div slot="content">此部分资金是您发布小任务<br/>时候的冻结款项解冻后可申<br/>请提现。</div>
            <i class="icon-information ion-information-circled"></i>
          </el-tooltip>
          冻结资金（元）
          <span class="span-money">{{$wallet.frozenMoney}}</span>
        </p>
      </div>
      <div class="part-3">
        <el-button type="primary" v-link-to="'/home/topUp'">充值</el-button>
        <el-button style="margin-left:38px" type="text" v-link-to="'/home/transferAcc'" v-if="$wallet.role===1">子账户余额管理 </el-button>
      </div>
    </div>
    <div class="content-center f-jb-ac">
      <div class="part part1" v-link-to="'/payment'">
      <div class="content-example"><span class="span-btn-example" @click.stop="btnShowExampleClick('_PAYMENT')">工资打款示例</span></div>
        <div class="f-jc-ac-dc">
          <img class="part-img" src="https://qiniu-image.qtshe.com//pc-qtbao/201800330/home-icon-1.png" alt="part-img"/>
          <p class="p-title">工资打款</p>
          <!-- <p class="p-act" @click.stop="btnShowActClick('_PAYMENT')">优惠活动</p> -->
          <p class="p-act"></p>
          <p>通过手机号码、姓名<br/>批量发放工资</p>
        </div>
      </div>
      <div class="part part2" v-link-to="'/invoiceApply'">
        <div class="content-example"><span class="span-btn-example" @click.stop="btnShowExampleClick('_INVOICE')">发票申请示例</span></div>
        <div class="f-jc-ac-dc">
          <img class="part-img" src="https://qiniu-image.qtshe.com//pc-qtbao/201800330/home-icon-2.png" alt="part-img"/>
          <p class="p-title">发票申请</p>
          <!-- <p class="p-act" @click.stop="btnShowActClick('_INVOICE')">优惠活动</p> -->
          <p class="p-act" style="margin-bottom: 20px;"></p>
          <p>在线申请劳务发票</p>
        </div>
      </div>
      <div class="part f-jc-ac-dc part3" v-link-to="'/billQuery'">
        <img class="part-img" src="https://qiniu-image.qtshe.com//pc-qtbao/201800330/home-icon-3.png" alt="part-img"/>
        <p class="p-title">对账查询</p>
        <p>收支明细查询账单下载</p>
      </div>
    </div>
    <div class="content-footer f-jb-ac" @click="dialogCooperationShowFlag=true"></div>
    <dialogCooperation :dialogVisible.sync="dialogCooperationShowFlag"/>
    <carousel :dialogVisible.sync="dialogCarouselShowFlag" :dialogData="dialogCarouselData"/>
    <dialogAct :dialogVisible.sync="dialogActShowFlag" :dialogData="dialogActData"/>
  </section>
</template>
<script>
  import {mapState, mapActions} from 'vuex'
  import dialogCooperation from '../modules/dialogCooperation'
  import carousel from '../modules/carousel'
  import dialogAct from '../modules/dialogAct'

  export default {
    components: {
      dialogCooperation,
      carousel,
      dialogAct
    },
    data() {
      return {
        dialogCooperationShowFlag: false,
        dialogCarouselShowFlag: false,
        dialogActShowFlag: false,
        dialogCarouselData: {},
        dialogActData: {}
      }
    },
    computed: {
      ...mapState('wallet', {
        $wallet: function (state) {
          return state || {}
        }
      }),
      ...mapState('user', {
        $userInfo: function (state) {
          return state || {company: {}}
        }
      })
    },
    mounted() {
      this.SET_WALLET()
    },
    methods: {
      ...mapActions('wallet', {
        SET_WALLET: 'SET_WALLET'
      }),
      handleRefresh() {
        this.$axios('/qtbCompanyCenter/wallet/jiangsuUpdateWallet').then((res) => {
          if (res.success) {
            this.$message.success('刷新成功')
            this.SET_WALLET()
          }
        }).catch(err => {
          console.log(err)
          this.$message.error('服务器错误，请稍后重试')
        })
      },
      btnShowExampleClick(type) {
        this.dialogCarouselData = {type}
        this.dialogCarouselShowFlag = true
      },
      btnShowActClick(type) {
        this.dialogActData = {type}
        this.dialogActShowFlag = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/home/components/main.vue